// Centralized API Configuration Constants
// This file contains all API-related constants that can be shared across the application
// Only two environments: localhost (development) and production (recoverycommons.com).

const detectEnvironment = (): 'development' | 'production' => {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'development';
  return 'production';
};

const ENV = detectEnvironment();

export const API_CONFIG = {
  BASE_URL: 'https://j4pza5h9ql.execute-api.us-east-1.amazonaws.com/Prod',
  ENVIRONMENT: ENV,
  FEATURES: {
    DEBUG_MODE: ENV === 'development',
    LOGGING: ENV === 'development',
    ANALYTICS: ENV === 'production'
  }
} as const;

export const getApiBaseUrl = (): string => API_CONFIG.BASE_URL;
export const getEnvironment = (): string => API_CONFIG.ENVIRONMENT;
export const isDevelopment = (): boolean => ENV === 'development';
export const isProduction = (): boolean => ENV === 'production'; 